/**
 * @readonly
 * @enum {string}
 */
const currency = require('./currency');

module.exports = {
    SMALL: {
        numberOfSms: 100,
        CZ: {
            price: 150, // cena za SMS 1,5 Kč = 100 * 1,5
            currency: currency.CZK,
        },
        SK: {
            price: 15, // cena za SMS 0.15 EUR = 100 * 0.15 EUR
            currency: currency.EUR,
        },
    },
    MEDIUM: {
        numberOfSms: 250,
        CZ: {
            price: 350, // cena za SMS 1,4 Kč = 250 * 1,4
            currency: currency.CZK,
        },
        SK: {
            price: 35, // cena za SMS 0.14 EUR = 250 * 0.14
            currency: currency.EUR,
        },
    },
    LARGE: {
        numberOfSms: 500,
        CZ: {
            price: 650, // cena za SMS 1,3 Kč = 500 * 1,3
            currency: currency.CZK,
        },
        SK: {
            price: 65, // cena za SMS 0.13 EUR = 500 * 0.13
            currency: currency.EUR,
        },
    },
};
